<template>
  <!--
    What the one shared link opens on (?room=FROG): which screen is this?
    The answer does exactly what ?join= or ?table= would have.
  -->
  <div class="screen room-choice">
    <p class="room-choice__lede">Joining room <strong>{{ code }}</strong></p>
    <h1 class="room-choice__title">What is this screen?</h1>
    <button class="primary room-choice__btn" type="button" @click="$emit('pick', false)">
      My player board
      <small class="action__sub">On your phone. You play a role from here.</small>
    </button>
    <button class="primary room-choice__btn" type="button" @click="$emit('pick', true)">
      The shared table
      <small class="action__sub">On a TV or laptop everyone can see. Shows the world.</small>
    </button>
  </div>
</template>

<script>
export default {
  name: 'RoomChoice',
  props: { code: { type: String, required: true } },
  emits: ['pick'],
};
</script>

<style scoped>
.room-choice { display: flex; flex-direction: column; justify-content: center; gap: 1rem; min-height: 100%; max-width: 32rem; margin: 0 auto; padding: 1.5rem; }
.room-choice__lede { margin: 0; color: var(--ink-dim); text-align: center; }
.room-choice__title { margin: 0 0 0.5rem; text-align: center; }
.room-choice__btn { padding: 1.2rem 1rem; font-size: 1.2rem; }
</style>
